import { Injectable } from '@angular/core';
import { FeatureState } from '@modeso/aumico-lib-core-fe';
import { Store, select } from '@ngrx/store';
import Debug from 'debug';
import * as fromComplementaryReportFilesActions from '../actions/complementary-report-files.actions';
import { financialClosingProcessItemDocument } from 'projects/aumico-project-reports/src/app/microservices/ms-annual-reports/financial-closing-process/domain/reducers/fcp.actions';

const debug = Debug('aumico:aumico-lib-core-fe:ComplementaryReportFilesProvider');

@Injectable({
    providedIn: 'root',
})
export class ComplementaryReportFilesProvider {
    constructor(private readonly store: Store<FeatureState>) {
        debug('ComplementaryReportFilesProvider constructed');
    }

    public dispatchUploadComplementaryReportFile(params: {
        sortOrderId: number;
        printLocation: string;
        documentFile: FormData;
    }): void {
        this.store.dispatch(
            fromComplementaryReportFilesActions.ComplementaryReportFilesActions.uploadComplementaryReportFile(params),
        );
    }

    public dispatchCheckPreviewStatus(fileId: string): void {
        this.store.dispatch(
            fromComplementaryReportFilesActions.ComplementaryReportFilesActions.checkPreviewStatus({ fileId }),
        );
    }

    public dispatchRequestPreviewGeneration(fileId: string): void {
        this.store.dispatch(
            fromComplementaryReportFilesActions.ComplementaryReportFilesActions.requestPreviewGeneration({ fileId }),
        );
    }

    public dispatchLoadPreviewUrl(fileId: string): void {
        this.store.dispatch(
            fromComplementaryReportFilesActions.ComplementaryReportFilesActions.loadPreviewUrl({ fileId }),
        );
    }

    public dispatchOpenFile(fileId: string): void {
        this.store.dispatch(fromComplementaryReportFilesActions.ComplementaryReportFilesActions.openFile({ fileId }));
    }

    public dispatchRevokeFileUrl(fileId: string): void {
        this.store.dispatch(
            fromComplementaryReportFilesActions.ComplementaryReportFilesActions.revokeFileUrl({ fileId }),
        );
    }

    public dispatchDownloadFile(documentId: string, documentName: string): void {
        this.store.dispatch(financialClosingProcessItemDocument.download({ documentId, documentName }));
    }
}
